/**
 * Paiements express — affichage conditionnel du libellé.
 *
 * Shopify écrit toujours le conteneur <shopify-accelerated-checkout>, même
 * lorsqu'aucun moyen express n'est proposé (Apple Pay hors Safari, Shop Pay
 * non activé, etc.). Le libellé « ou payer en un geste » ne doit donc pas être
 * affiché tant qu'un bouton n'a pas réellement été peint : sinon la page
 * annonce une facilité qui n'existe pas.
 *
 * Le libellé est masqué par défaut en CSS ; on le révèle ici, et seulement ici.
 *
 * Vitesse 25/10 : la hauteur du conteneur est fournie par un ResizeObserver,
 * pendant le rendu du navigateur, au lieu d'être lue (offsetHeight) à chaque
 * mutation du DOM, au DOMContentLoaded et par trois minuteurs : c'était le
 * premier poste de mises en page forcées de la fiche (0,9 à 1,5 s en CPU ×4).
 * Même règle qu'avant : libellé visible si et seulement si la boîte bordure
 * du conteneur dépasse 8 px (0 si le conteneur, ou un parent, est masqué).
 * Le ResizeObserver signale aussi les redimensionnements tardifs des iframes,
 * que les minuteurs rattrapaient. Sans ResizeObserver (navigateurs anciens),
 * l'ancien fonctionnement est conservé tel quel (repli offsetHeight).
 */
(function () {
  'use strict';

  var SELECTEUR_LABEL = '.product-form__express-label, .cart__express-label';

  function boutonsVisibles(conteneur) {
    if (!conteneur) return false;
    // offsetParent écarte les conteneurs masqués ; la hauteur écarte les vides.
    return conteneur.offsetHeight > 8;
  }

  function conteneurApres(label) {
    var el = label.nextElementSibling;
    while (el) {
      if (el.matches('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons, .shopify-payment-button')) {
        return el;
      }
      el = el.nextElementSibling;
    }
    return null;
  }

  /* ---------- Repli sans ResizeObserver : fonctionnement d'origine ---------- */
  function evaluer(label) {
    var conteneur = conteneurApres(label);
    label.classList.toggle('is-visible', boutonsVisibles(conteneur));
  }

  function evaluerTout() {
    document.querySelectorAll(SELECTEUR_LABEL).forEach(evaluer);
  }

  /* ---------- Vitesse 25/10 : ResizeObserver ---------- */
  var ro = null;
  var libelleDe = null;   // conteneur -> libellé qu'il commande
  var conteneurDe = null; // libellé -> conteneur suivi
  var suivis = [];        // conteneurs observés, pour cesser de suivre ceux retirés du DOM

  // Hauteur de la boîte bordure, arrondie au pixel comme offsetHeight.
  function hauteur(entree) {
    var b = entree.borderBoxSize;
    if (b) {
      b = b[0] || b; // anciennes versions de Firefox : un objet au lieu d'une liste
      if (b && typeof b.blockSize === 'number') return Math.round(b.blockSize);
    }
    // Navigateurs sans borderBoxSize : la mise en page vient d'être calculée,
    // la lecture ne force pas de recalcul (toutes les lectures précèdent les écritures).
    return entree.target.offsetHeight;
  }

  if (typeof window.ResizeObserver === 'function') {
    libelleDe = new WeakMap();
    conteneurDe = new WeakMap();
    ro = new window.ResizeObserver(function (entrees) {
      // Lectures d'abord, écritures ensuite.
      var maj = [];
      entrees.forEach(function (e) {
        var label = libelleDe.get(e.target);
        if (!label || !label.isConnected || conteneurDe.get(label) !== e.target) return;
        maj.push([label, hauteur(e) > 8]);
      });
      maj.forEach(function (m) { m[0].classList.toggle('is-visible', m[1]); });
    });
  }

  function lier(label) {
    var c = conteneurApres(label);
    var ancien = conteneurDe.get(label) || null;
    if (c === ancien) return;
    if (ancien) {
      ro.unobserve(ancien);
      libelleDe.delete(ancien);
    }
    // Nouveau conteneur : masqué jusqu'à la mesure du navigateur, livrée avant
    // la prochaine peinture (aucun clignotement). Un conteneur de hauteur nulle
    // ne produit pas de mesure initiale : le libellé reste masqué, comme avant.
    label.classList.remove('is-visible');
    if (!c) {
      conteneurDe.delete(label);
      return;
    }
    conteneurDe.set(label, c);
    libelleDe.set(c, label);
    if (suivis.indexOf(c) < 0) suivis.push(c);
    // Après relecture : observe() sur un élément déjà observé ne relance pas de mesure
    // initiale. Si un libellé neuf se rattache à un conteneur encore suivi (libellé
    // remplacé seul), on repart d'une observation neuve pour qu'il soit mesuré.
    ro.unobserve(c);
    ro.observe(c, { box: 'border-box' });
  }

  function lierTout() {
    // Le tiroir panier est re-rendu à chaque ajout : on cesse de suivre les
    // conteneurs qui ne sont plus dans le document.
    suivis = suivis.filter(function (c) {
      if (c.isConnected) return true;
      ro.unobserve(c);
      return false;
    });
    document.querySelectorAll(SELECTEUR_LABEL).forEach(lier);
  }

  // Sans lecture de mise en page avec le ResizeObserver ; évaluation d'origine sinon.
  var majTout = ro ? lierTout : evaluerTout;

  // Les boutons express arrivent de façon asynchrone (iframes tierces) et le
  // tiroir panier est re-rendu à chaque ajout : on observe au lieu de deviner.
  var observateur = new MutationObserver(function () {
    // Regroupe les rafales de mutations en une seule évaluation.
    window.cancelAnimationFrame(observateur._t);
    observateur._t = window.requestAnimationFrame(majTout);
  });

  function demarrer() {
    majTout();
    observateur.observe(document.body, { childList: true, subtree: true });
    if (!ro) {
      // Filet de sécurité (repli) : certaines iframes se dimensionnent après leur insertion.
      [400, 1200, 2500].forEach(function (d) { window.setTimeout(evaluerTout, d); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
